import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const rootEl = document.getElementById('root');
const tree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Pre-rendered routes ship real HTML in #root -> hydrate it.
// The plain SPA fallback ships an empty #root -> client-render it.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
